export { IconWithLabel } from "./IconWithLabel";